import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="offcanvas"
export default class extends Controller {
  static targets = [ "canvas", "backdrop" ]

  initialize() {
    this.close = this.close.bind(this)
  }

  open(){
  //   Add "showing" class to off canvas target then when scrolled replaces showing with "show"
    this.canvasTarget.classList.add("showing")
    this.addBackdrop()

    Promise.all(this.canvasTarget.getAnimations().map((animation) => animation.finished)).then(() => {
      this.canvasTarget.classList.remove("showing")
      this.canvasTarget.classList.add("show")
    })
  }
  close(){
  //   Add "hiding" class to off canvas target then remove both "hiding" and "show"
    this.canvasTarget.classList.add("hiding")
    this.removeBackdrop()

    Promise.all(this.canvasTarget.getAnimations().map((animation) => animation.finished)).then(() => {
      this.canvasTarget.classList.remove("hiding", "show")
    })
  }

  backdropTargetConnected(element) {
    element.addEventListener("click", this.close)
  }

  backdropTargetDisconnected(element) {
    element.removeEventListener("click", this.close)
  }

  addBackdrop(){
    const backdrop = document.createElement("div")
    backdrop.classList.add("offcanvas-backdrop", "fade", "showing")
    backdrop.dataset.offcanvasTarget = "backdrop"
    this.canvasTarget.parentNode.appendChild(backdrop)

    Promise.all(this.backdropTarget.getAnimations().map((animation) => animation.finished)).then(() => {
      this.backdropTarget.classList.replace("showing", "show")
    })
  }
  removeBackdrop(){
    this.backdropTarget.classList.remove("showing")

    Promise.all(this.backdropTarget.getAnimations().map((animation) => animation.finished)).then(() => {
      this.backdropTarget.remove()
    })
  }
}
